import { useFormContext, Controller } from "react-hook-form";
import { FiChevronDown, FiX } from "react-icons/fi";
import input from "./FormStyle/input.module.css";
import { FileUploader } from "react-drag-drop-files";
import Upload from "../../Images/upload.svg";
import UploadCloud from "../../Images/upload-cloud.svg";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DashboardStyle from "../../Styles/Dashboard.module.css";
import React, { useState, useEffect, useRef } from "react";
import { twMerge } from "tailwind-merge";
// import "./Style/Form/style.css";
export function FormTemplate({ children, handleSubmit, className }) {
  return (
    <form
      className={className || DashboardStyle.view_app_components}
      onSubmit={handleSubmit}
    >
      {children}
    </form>
  );
}

export function FormLabel({ camelCase, title, isOptional, style, value }) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase?.replace(/"/g, "");

  return (
    <div style={{ ...style }} className={input.input_container}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <div className={input.input_field} id={camelCase}>
        {value}
      </div>
      <small className={input.form__error__message}>
        {(errors || errors?.[inputName]) &&
          `${errors?.[inputName]?.message || ""}`}
      </small>
    </div>
  );
}

// export function FormInput({
//   camelCase,
//   placeholder,
//   title,
//   type,
//   isOptional,
//   disabled,
//   className,
//   message,
//   value,
//   defaultValue,
//   registerOptions,
//   step,
//   style,
//   minDate,
// }) {
//   const {
//     register,
//     formState: { errors },
//   } = useFormContext();

//   const inputName = camelCase?.replace(/"/g, "");

//   return (
//     <div style={{ ...style }} className={input.input_container}>
//       {title && (
//         <label className={input.input_title} htmlFor={camelCase}>
//           {title}
//           <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
//         </label>
//       )}
//       {/* <div> */}{" "}
//       <input
//         className={`${input.input_field} ${
//           errors?.[inputName] && input.form__error__message_border
//         }`}
//         disabled={disabled || false}
//         // value={value}
//         // value={value === null ? '' : value}
//         value={value === null ? undefined : value}
//         type={type}
//         name={camelCase}
//         id={camelCase}
//         step={step && "0.01"}
//         placeholder={`Enter ${title}`}
//         min={minDate}
//         // defaultValue={defaultValue}
//         defaultValue={value === null ? undefined : defaultValue}
//         {...register(camelCase, {
//           required: {
//             value: isOptional === true ? false : true,
//             message: `${title || "This field"} is required.`,
//           },
//           ...registerOptions,
//         })}
//       />
//       <small className={input.form__error__message}>
//         {(errors || errors?.[inputName]) &&
//           `${errors?.[inputName]?.message || ""}`}
//       </small>
//       {/* )} */}
//     </div>
//   );
// }

export function FormattedNumberInput({
  camelCase,
  placeholder = "Enter value",
  title,
  isOptional = false,
  disabled = false,
  className = "",
  message = "",
  value, // External value prop
  defaultValue,
  registerOptions = {},
  style = {},
}) {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();

  const inputName = camelCase?.replace(/"/g, "");
  const [formattedValue, setFormattedValue] = useState("");

  // Watch the current field value if no external value is provided
  const watchedValue = watch(inputName);

  // Format number with commas without decimal places
  const formatToMoney = (num) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num);
  };

  // Parse value to a numeric form without commas
  const parseToNumber = (val) => {
    return parseFloat(val?.toString().replace(/,/g, ""));
  };

  // Update formattedValue when `value` (external) or `watchedValue` changes
  useEffect(() => {
    const newValue = value !== undefined ? value : watchedValue ?? defaultValue;
    const numericValue = parseToNumber(newValue);
    if (!isNaN(numericValue)) {
      setFormattedValue(formatToMoney(numericValue));
    } else {
      setFormattedValue(""); // Clear if NaN or invalid
    }
  }, [value, watchedValue, defaultValue]);

  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas
    if (rawValue === "") {
      setFormattedValue("");
      setValue(inputName, undefined); // Set value to undefined if empty
    } else if (!isNaN(rawValue)) {
      setFormattedValue(formatToMoney(rawValue)); // Format for display
      setValue(inputName, parseToNumber(rawValue)); // Set raw numeric value
    }
  };

  const handleBlur = () => {
    const numericValue = parseToNumber(formattedValue);
    if (!isNaN(numericValue)) {
      setFormattedValue(formatToMoney(numericValue));
    }
  };

  const handleFocus = () => {
    setFormattedValue((prev) => prev.replace(/,/g, "")); // Show raw input on focus
  };

  const preventNegativeInput = (e) => {
    if (e.key === "-" || e.key === "e") {
      e.preventDefault();
    }
  };

  return (
    <div style={style} className={`${className} ${input.input_container}`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{isOptional ? "" : "*"}</sup>
        </label>
      )}

      <input
        className={`${input.input_field} ${
          errors?.[inputName] && input.form__error__message_border
        }`}
        disabled={disabled}
        value={formattedValue}
        type="text"
        name={camelCase}
        id={camelCase}
        placeholder={placeholder || `Enter ${title}`}
        onKeyDown={preventNegativeInput}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        {...register(camelCase, {
          required: !isOptional
            ? `${title || "This field"} is required.`
            : false,
          validate: (val) => {
            if (disabled) return true; // Skip validation if field is disabled
            if (val === undefined || val === null || val === "")
              return "Please enter a valid number."; // Check for empty values
            const numericValue = parseToNumber(val);
            return (
              (!isNaN(numericValue) && numericValue > 0) ||
              "Please enter a valid number."
            );
          },
          ...registerOptions,
        })}
      />

      {message && <small className={input.input_message}>{message}</small>}

      <small className={input.form__error__message}>
        {errors?.[inputName]?.message || ""}
      </small>
    </div>
  );
}
export function CustomFloatSearchableSelect({
  camelCase,
  placeholder,
  title,
  isOptional,
  defaultValue,
  // defaultId,
  options,
  disabled,
  message,
  multiple,
  moreRegister,
  isLoading,
  arrayLenghtNotice,
  setSearch,
  specTitle,
}) {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const {
    register,
    setValue, // Add setValue from useFormContext
    watch,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase.replace(/\"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  const select_title = title || specTitle;

  // Watch current form value for this field
  const watchedValue = watch(inputName);

  // Determine the current value for the Select component
  const currentValue = multiple
    ? (watchedValue || defaultValue || [])
        .map((val) =>
          typeof val === "object"
            ? val
            : options?.find((opt) => opt.value === val)
        )
        .filter(Boolean)
    : typeof (watchedValue || defaultValue) === "object"
    ? watchedValue || defaultValue
    : options?.find((opt) => opt.value === (watchedValue || defaultValue)) ||
      null;

  return (
    <div className={`input_container w-full`}>
      {select_title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {select_title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <div className={input.select_holder_searchable}>
        <Select
          name={camelCase}
          id={camelCase}
          options={options}
          value={currentValue}
          isMulti={multiple}
          closeMenuOnSelect={!multiple}
          onInputChange={(val) => setSearch && setSearch(val)}
          placeholder={placeholder}
          isDisabled={disabled === "disabled"}
          onChange={(selectedOption) => {
            // console.log({ selectedOption });
            setSelectedValue(selectedOption);
            if (multiple) {
              // Check if Visitation (value 3) is selected
              if (selectedOption.some((opt) => opt.value === 3)) {
                // If Visitation is selected, restrict to only Visitation
                setValue(camelCase, [3]);
              } else {
                setValue(
                  camelCase,
                  selectedOption ? selectedOption.map((opt) => opt.value) : []
                );
              }
            } else {
              setValue(camelCase, selectedOption ? selectedOption.value : null);
            }
            if (moreRegister && moreRegister.onChange) {
              moreRegister.onChange(selectedOption);
            }
          }}
        />
      </div>
      {(errors || errors?.[inputName]) && (
        <small className={input.form__error__message}>
          {errors?.[inputName]?.message ||
            errors?.[groupName]?.[groupIndex]?.[fieldInputName]?.message}
        </small>
      )}
      {isLoading && <small>Loading...</small>}
      {!options?.length && (
        <small>{arrayLenghtNotice || "No available Options"}</small>
      )}
    </div>
  );
}
export function FormInputMax({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  disabled,
  className,
  message,
  value,
  defaultValue,
  registerOptions,
  step,
  style,
  minDate,
  max, // Add max as a prop
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase?.replace(/"/g, "");

  // Function to block the minus key
  const preventNegativeInput = (e) => {
    if (e.key === "-" || e.key === "e") {
      e.preventDefault();
    }
  };

  // Function to enforce the max value
  const enforceMaxValue = (e) => {
    if (max && parseFloat(e.target.value) > max) {
      e.target.value = max; // Set the value to the max if exceeded
    }
  };

  return (
    <div style={{ ...style }} className={input.input_container}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <input
        className={`${input.input_field} ${
          errors?.[inputName] && input.form__error__message_border
        }`}
        disabled={disabled || false}
        value={value === null ? undefined : value}
        type={type}
        name={camelCase}
        id={camelCase}
        step={step && "0.01"}
        placeholder={placeholder || `Enter ${title}`}
        min={type === "number" ? "0" : minDate}
        max={type === "number" ? max : undefined} // Apply max if type is "number"
        defaultValue={value === null ? undefined : defaultValue}
        onKeyDown={type === "number" ? preventNegativeInput : undefined} // Prevent minus sign
        onInput={type === "number" ? enforceMaxValue : undefined} // Enforce max value
        {...register(camelCase, {
          required: {
            value: isOptional === true ? false : true,
            message: `${title || "This field"} is required.`,
          },
          ...registerOptions,
        })}
      />
      <small className={input.form__error__message}>
        {(errors || errors?.[inputName]) &&
          `${errors?.[inputName]?.message || ""}`}
      </small>
    </div>
  );
}

export function FormInput({
  camelCase,
  placeholder,
  readOnly,
  title,
  type,
  isOptional,
  disabled,
  className,
  message,
  value,
  defaultValue,
  registerOptions,
  step,
  onChange,
  style,
  minDate,
  max,
  hideTitle = false, // New prop to hide title
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase?.replace(/"/g, "");
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };
  // Function to block the minus key
  const preventNegativeInput = (e) => {
    if (e.key === "-" || e.key === "e") {
      e.preventDefault();
    }
  };

  return (
    <div
      style={{ ...style }}
      className={twMerge(input.input_container, className)}
    >
      {title && !hideTitle && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <input
        readOnly={readOnly}
        className={`${input.input_field} ${
          errors?.[inputName] && input.form__error__message_border
        }`}
        disabled={disabled || false}
        value={value === null ? undefined : value}
        type={type}
        name={camelCase}
        id={camelCase}
        step={step && "0.01"}
        placeholder={`Enter ${title}`}
        min={type === "number" ? "0" : minDate}
        max={max}
        defaultValue={value === null ? undefined : defaultValue}
        onKeyDown={type === "number" ? preventNegativeInput : undefined} // Prevent minus sign
        {...register(camelCase, {
          required: {
            value: isOptional === true ? false : true,
            message: `${title || "This field"} is required.`,
          },
          ...registerOptions,
        })}
        {...(onChange ? { onChange: handleChange } : {})}
      />
      <small className={input.form__error__message}>
        {(errors || errors?.[inputName]) &&
          `${errors?.[inputName]?.message || ""}`}
      </small>
    </div>
  );
}

export function FormInputHidden({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  disabled,
  className,
  message,
  value,
  defaultValue,
  registerOptions,
  step,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase?.replace(/"/g, "");

  return (
    <div className={input.input_container}>
      <input
        className={`${input.input_field} ${
          errors?.[inputName] && input.form__error__message_border
        }`}
        disabled={disabled || false}
        value={value}
        type={type}
        name={camelCase}
        id={camelCase}
        defaultValue={defaultValue}
      />
    </div>
  );
}

export function FormSelect({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  message,
  multiple,
  onChange,
  moreRegister,
  isLoading,
  arrayLenghtNotice,
  specTitle,
  className = "",
}) {
  const dee = useRef(Date.now());
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase.replace(/"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  const select_title = title || specTitle;

  return (
    <div className={twMerge(`${input.input_container}`, className)}>
      {select_title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {select_title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <div key={`${camelCase}-${dee.current}`} className={input.select_holder}>
        <select
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          type={type}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          multiple={multiple && true}
          defaultValue={defaultId || defaultValue}
          {...register(camelCase, {
            required: {
              value: isOptional === true ? false : true,
              message: `${title || "This feild"} is required.`,
            },
            onChange: (e) => {
              if (typeof onChange === "function") {
                onChange(e);
              }
            },
            ...moreRegister,
          })}
          disabled={disabled === "disabled" || disabled === true ? true : false}
        >
          {!defaultValue && (
            <option value="" disabled>{`Select ${title || "Options"}`}</option>
          )}
          {defaultValue && (
            <option value={defaultId} selected>
              {defaultValue}
            </option>
          )}
          {array || null}
        </select>
        <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span>
      </div>
      {/* <br /> */}
      <>
        {(errors || errors?.[inputName]) && (
          <small className={input.form__error__message}>
            {errors?.[inputName]?.message ||
              errors?.[groupName]?.[groupIndex]?.[fieldInputName]?.message}
          </small>
        )}
        {/* <br /> */}
        {isLoading && <small>Loading...</small>}
        {!array?.length &&
          (<small>{arrayLenghtNotice}</small> || (
            <small>No available Options</small>
          ))}
      </>
    </div>
  );
}

export function FormSelectA({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  message,
  multiple,
  moreRegister,
  isLoading,
  arrayLenghtNotice,
  specTitle,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase.replace(/"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  const select_title = title || specTitle;

  return (
    <div className={`${input.input_container}`}>
      {select_title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {select_title}
          <sup style={{ color: "red" }}>{isOptional ? "" : "*"}</sup>
        </label>
      )}
      <div key={"s1"} className={input.select_holder}>
        <select
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          type={type}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          multiple={multiple}
          {...register(camelCase, {
            required: {
              value: !isOptional,
              message: `${title || "This field"} is required.`,
            },
            ...moreRegister,
          })}
          disabled={disabled === "disabled"}
        >
          <option value="" disabled>
            Select {title || "Options"}
          </option>
          {defaultValue && <option value={defaultId}>{defaultValue}</option>}
          {array}
        </select>
        <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span>
      </div>
      <>
        {(errors || errors?.[inputName]) && (
          <small className={input.form__error__message}>
            {errors?.[inputName]?.message ||
              errors?.[groupName]?.[groupIndex]?.[fieldInputName]?.message}
          </small>
        )}
        {isLoading && <small>Loading...</small>}
        {!array?.length && (
          <small>{arrayLenghtNotice || "No available Options"}</small>
        )}
      </>
    </div>
  );
}

export const FormSelectNew = ({
  title,
  camelCase,
  placeholder,
  isOptional,
  array,
}) => {
  return (
    <select className={DashboardStyle.form_input}>
      <option value="">{placeholder}</option>
      {array?.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export function FormSelect3({
  camelCase,
  placeholder,
  title,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  moreRegister,
  isLoading,
  arrayLenghtNotice,
  specTitle,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext(); // Hook from react-hook-form to manage form state

  const inputName = camelCase.replace(/"/g, "");
  const selectTitle = title || specTitle;

  return (
    <div className={`${input.input_container}`}>
      {selectTitle && (
        <label className={input.input_title} htmlFor={camelCase}>
          {selectTitle}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <div className={input.select_holder}>
        <select
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder || `Select ${selectTitle || "Options"}`}
          defaultValue={defaultValue || undefined} // Use defaultValue if provided
          {...register(camelCase, {
            required: {
              value: !isOptional, // Set required based on isOptional prop
              message: `${selectTitle || "This field"} is required.`,
            },
            ...moreRegister, // Additional validations
          })}
          disabled={disabled === "disabled"}
        >
          {!defaultValue && ( // Only render default placeholder option if no defaultValue provided
            <option value="" disabled>
              {`Select ${selectTitle || "Options"}`}
            </option>
          )}
          {defaultValue && ( // Render defaultValue if provided
            <option value={defaultId} selected>
              {defaultValue}
            </option>
          )}
          {array} {/* Render dynamic options from array prop */}
        </select>
        <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span>
      </div>
      {/* Display validation errors */}
      {errors?.[inputName] && (
        <small className={input.form__error__message}>
          {errors?.[inputName]?.message}
        </small>
      )}
      {/* Display loading state */}
      {isLoading && <small>Loading...</small>}
      {/* Display notice if no options */}
      {!array?.length && (
        <small>{arrayLenghtNotice || "No available options"}</small>
      )}
    </div>
  );
}

// FormSelect component
export function FormSelect2({
  camelCase,
  placeholder,
  title,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  // Other props...
}) {
  // Destructuring form context
  const {
    register,
    formState: { errors },
  } = useFormContext();

  // Parsing input name
  const inputName = camelCase.replace(/"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  // Rendering
  return (
    <div className={`${input.input_container}`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <div key={"s1"} className={input.select_holder}>
        <select
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          defaultValue={defaultValue}
          {...register(camelCase, {
            required: {
              value: isOptional === true ? false : true,
              message: `${title || "This field"} is required.`,
            },
            // Other register props...
          })}
          disabled={disabled === "disabled" ? true : false}
        >
          {/* <option value="" disabled selected>
            {`Select ${title || "Options"}`}
          </option> */}
          {defaultValue && (
            <option value={defaultId} selected>
              {defaultValue}
            </option>
          )}
          {array || null}
        </select>
        <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span>
      </div>
      {/* Error handling and other messages */}
      {errors && errors[inputName] && (
        <small className={input.form__error__message}>
          {errors[inputName].message}
        </small>
      )}
      {/* {!array?.length && <small>{arrayLenghtNotice || "No available Options"}</small>} */}
    </div>
  );
}

// const CustomSearchableSelect = ({
//   camelCase,
//   placeholder,
//   title,
//   isOptional,
//   defaultValue,
//   defaultId,
//   options,
//   isLoading,
//   moreRegister,
// }) => {
//   return (
//     <div className={`${input.input_container}`}>
//       {title && (
//         <label className={input.input_title} htmlFor={camelCase}>
//           {title}
//           {isOptional === false && <sup style={{ color: "red" }}>*</sup>}
//         </label>
//       )}
//       <div className={input.select_holder}>
//         <Select
//           className={`${input.input_field} ${input.select_field}`}
//           classNamePrefix="react-select"
//           id={camelCase}
//           name={camelCase}
//           placeholder={placeholder || `Select ${title || "Options"}`}
//           defaultValue={defaultValue ? { value: defaultId, label: defaultValue } : null}
//           options={options}
//           {...moreRegister}
//         />
//       </div>
//       {isLoading && <small>Loading...</small>}
//     </div>
//   );
// };

// export default CustomSearchableSelect;
export function CustomSearchableSelect({
  camelCase,
  placeholder,
  title,
  isOptional,
  defaultValue,
  // defaultId,
  options,
  disabled,
  message,
  multiple,
  moreRegister,
  isLoading,
  arrayLenghtNotice,
  setSearch,
  specTitle,
  showCount = false,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase.replace(/\"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  const select_title = title || specTitle;
  const [selected, setSelected] = useState([]);
  return (
    <div className={`input_container w-full`}>
      {select_title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {select_title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <div className={input.select_holder_searchable}>
        <Controller
          name={camelCase}
          control={control}
          rules={{
            required: !isOptional ? `${select_title} is required.` : false,
          }}
          defaultValue={defaultValue}
          render={({ field }) => (
            <Select
              {...field}
              options={options}
              isMulti={multiple}
              closeMenuOnSelect={!multiple}
              onInputChange={(val) => setSearch && setSearch(val)}
              placeholder={placeholder}
              isDisabled={disabled === "disabled"}
              onChange={(selectedOption) => {
                field.onChange(selectedOption);
                if (moreRegister && moreRegister.onChange) {
                  moreRegister.onChange(selectedOption);
                  setSelected(selectedOption);
                }
              }}
            />
          )}
        />
      </div>
      {showCount && selected?.length >= 0 && (
        <small className="text-gray-500">
          {selected?.length} option{selected?.length !== 1 ? "s" : ""} selected
        </small>
      )}
      {(errors || errors?.[inputName]) && (
        <small className={input.form__error__message}>
          {errors?.[inputName]?.message ||
            errors?.[groupName]?.[groupIndex]?.[fieldInputName]?.message}
        </small>
      )}
      {isLoading && <small>Loading...</small>}
      {!options?.length && (
        <small>{arrayLenghtNotice || "No available Options"}</small>
      )}
    </div>
  );
}

export function SearchableFormSelect({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  message,
  multiple,
  moreRegister,
  isLoading,
  arrayLenghtNotice,
  specTitle,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase.replace(/"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  const select_title = title || specTitle;

  return (
    <div className={`${input.input_container}`}>
      {select_title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {select_title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <div className={input.select_holder}>
        <select
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          type={type}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          multiple={multiple && true}
          {...register(camelCase, {
            required: {
              value: isOptional === true ? false : true,
              message: `${title || "This field"} is required.`,
            },
            ...moreRegister,
          })}
          disabled={disabled === "disabled" ? true : false}
        >
          <option value="" disabled>
            {`Select ${title || "Options"}`}
          </option>
          {defaultValue && (
            <option value={defaultId} selected>
              {defaultValue || "a"}
            </option>
          )}
          {array?.map((acquisition, index) => (
            <option key={index} value={acquisition?.id}>
              {`${acquisition?.consumable} [${acquisition?.beneficiaryTypeDesc} - ${acquisition?.beneficiaryName}]`}
            </option>
          ))}
        </select>
        <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span>
      </div>
      {errors && errors[inputName] && (
        <small className={input.form__error__message}>
          {errors[inputName]?.message ||
            errors[groupName]?.[groupIndex]?.[fieldInputName]?.message}
        </small>
      )}
      {isLoading && <small>Loading...</small>}
      {!array?.length && (
        <small>{arrayLenghtNotice || "No available Options"}</small>
      )}
    </div>
  );
}

export function FormsSelect({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  message,
  multiple,
  moreRegister,
  isLoading,
  arrayLenghtNotice,
  className,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase.replace(/"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  // const ref = useRef(null);

  // const handleAutoFocus = () => {
  //   ref.current.focus();
  // };

  return (
    <div className={twMerge(`${input.input_container}`, className)}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <div className={input.select_holder}>
        <select
          style={{ color: "#6e9170" }}
          // ref={ref}
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          type={type}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          multiple={multiple && true}
          // defaultValue={defaultValue}
          {...register(camelCase, {
            required: {
              value: isOptional === true ? false : true,
              message: `${title || "This feild"} is required.`,
            },
            ...moreRegister,
          })}
          disabled={disabled === "disabled" ? true : false}
        >
          {/* {!defaultValue && ( */}
          <option value="" className={input.input_title}>
            {placeholder}
          </option>
          {/* )} */}
          {defaultValue ? (
            <option value={defaultId} selected>
              {defaultValue || "a"}
            </option>
          ) : (
            ""
          )}
          {array || null}
        </select>
        <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span>
      </div>
      {/* <br /> */}
      <>
        {(errors || errors?.[inputName]) && (
          <small className={input.form__error__message}>
            {errors?.[inputName]?.message ||
              errors?.[groupName]?.[groupIndex]?.[fieldInputName]?.message}
          </small>
        )}
        {/* <br /> */}
        {isLoading && <small>Loading...</small>}
        {!array?.length &&
          (<small>{arrayLenghtNotice}</small> || (
            <small>No available Options</small>
          ))}
      </>
    </div>
  );
}

// Other imports...

export function FormsStandardSelect({
  camelCase,
  placeholder,
  title,
  isOptional,
  defaultValue,
  array,
  disabled,
  multiple,
  moreRegister,
  isLoading,
  arrayLenghtNotice,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase.replace(/"/g, "");

  return (
    <div className={`${input.input_container}`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      <div className={input.select_holder}>
        <select
          style={{ color: "#6e9170" }}
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          multiple={multiple && true}
          {...register(camelCase, {
            required: {
              value: isOptional === true ? false : true,
              message: `${title || "This field"} is required.`,
            },
            ...moreRegister,
          })}
          disabled={disabled === "disabled" ? true : false}
        >
          <option value="" className={input.input_title} disabled>
            {placeholder}
          </option>
          {array || null}
        </select>
        <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span>
      </div>
      <>
        {(errors || errors?.[inputName]) && (
          <small className={input.form__error__message}>
            {errors?.[inputName]?.message}
          </small>
        )}
        {isLoading && <small>Loading...</small>}
        {!array?.length && (
          <small>{arrayLenghtNotice || "No available Options"}</small>
        )}
      </>
    </div>
  );
}

export function FormTextArea({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  className,
  rowsLines,
  moreRegister,
  textAreaClassName,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase?.replace(/"/g, "");
  return (
    <div className={`${input.input_container} ${className}`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      {/* <br /> */}
      <div>
        {" "}
        <textarea
          className={`${textAreaClassName} ${input.input_field} `}
          type={type}
          name={camelCase}
          id={camelCase}
          defaultValue={defaultValue}
          placeholder={`Enter ${title}`}
          {...register(camelCase, {
            // required: {
            //   value: isOptional !== true ? false : true,
            //   message: `${title || "This feild"} is required.`,
            // },
            required: {
              value: isOptional === true ? false : true,
              message: `${title || "This field"} is required.`,
            },

            ...moreRegister,
          })}
          disabled={disabled === "disabled" ? true : false}
          cols="20"
          rows={rowsLines || "7"}
        ></textarea>
        {/* <br /> */}
        <>
          {errors?.[inputName] && (
            <small className={input.form__error__message}>
              {errors?.[inputName].message}
            </small>
          )}
        </>
      </div>
    </div>
  );
}

export function FormReadonlyTextArea({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  className,
  rowsLines,
  moreRegister,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase?.replace(/"/g, "");
  return (
    <div className={`${input.input_container} ${className}`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{isOptional === true ? "" : "*"}</sup>
        </label>
      )}
      {/* <br /> */}
      <div>
        {" "}
        <textarea
          className={input.input_field}
          type={type}
          name={camelCase}
          id={camelCase}
          defaultValue={defaultValue}
          placeholder={`[Autogenerated]`}
          {...register(camelCase, {
            // required: {
            //   value: isOptional !== true ? false : true,
            //   message: `${title || "This feild"} is required.`,
            // },
            required: {
              value: isOptional === true ? false : true,
              message: `${title || "This field"} is required.`,
            },

            ...moreRegister,
          })}
          disabled={disabled === "disabled" ? true : false}
          cols="20"
          rows={rowsLines || "7"}
        ></textarea>
        {/* <br /> */}
        <>
          {errors?.[inputName] && (
            <small className={input.form__error__message}>
              {errors?.[inputName].message}
            </small>
          )}
        </>
      </div>
    </div>
  );
}
export function TextArea({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  className,
  rowsLines,
  moreRegister,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase?.replace(/"/g, "");
  return (
    <div className={`${input.input_container} ${className}`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          {isOptional !== false && <sup style={{ color: "red" }}>*</sup>}
        </label>
      )}
      {/* <br /> */}
      <div>
        {" "}
        <textarea
          className={input.input_field}
          type={type}
          name={camelCase}
          id={camelCase}
          defaultValue={defaultValue}
          placeholder={`Enter answer`}
          {...register(camelCase, {
            required: {
              value: isOptional !== true ? false : true,
              message: `${title || "This field"} is required.`,
            },
            ...moreRegister,
          })}
          disabled={disabled === "disabled" ? true : false}
          cols="20"
          rows={rowsLines || "7"}
        ></textarea>
        {/* <br /> */}
        <>
          {errors?.[inputName] && (
            <small className={input.form__error__message}>
              {errors?.[inputName].message}
            </small>
          )}
        </>
      </div>
    </div>
  );
}

export function FileUpload({
  title,
  camelCase,
  setFile,
  file,
  isOptional,
  moreRegister,
  multiple,
}) {
  const fileTypes = ["JPG", "PNG", "PDF"];

  const handleChange = (file) => {
    setFile(file);
  };
  return (
    <div className={input.input_container}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          {!isOptional && <sup style={{ color: "red" }}>*</sup>}
        </label>
      )}
      {file && (
        <FiX
          onClick={(e) => {
            e.stopPropagation();
            setFile(null);
          }}
          className={input.cancel_file_upload}
        />
      )}
      <FileUploader
        classes={input.file_uploader}
        handleChange={handleChange}
        onDrop={handleChange}
        name="file"
        types={fileTypes}
        hoverTitle={"Drop here"}
        multiple={multiple || false}
      >
        {file ? (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={input.file_uploader_active}
          >
            <p>{file?.name}</p>
            {/* <p
              onClick={(e) => {
                e.stopPropagation();
                setFile(null);
              }}
              className={input.file_upload_cancel}
            >
              Replace
            </p> */}
          </div>
        ) : (
          <div className={input.file_uploader_empty_state}>
            <img src={Upload} alt="File Upload" />
            <div>
              <p>
                Drag and drop here or <b>click</b> to upload.
              </p>
              <p>(JFG/PNG/PDF)</p>
            </div>
          </div>
        )}
      </FileUploader>
    </div>
  );
}

export function FileUploadAlt({
  title,
  camelCase,
  setFile,
  file,
  isOptional,
  moreRegister,
  multiple,
  fileTypes = ["JPG", "PNG", "PDF"],
}) {
  const handleChange = (file) => {
    setFile(file);
  };
  return (
    <div className={input.input_container}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          {!isOptional && <sup style={{ color: "red" }}>*</sup>}
        </label>
      )}
      {file && (
        <FiX
          onClick={(e) => {
            e.stopPropagation();
            setFile(null);
          }}
          className={input.cancel_file_upload}
        />
      )}
      <FileUploader
        classes={input.file_uploader}
        handleChange={handleChange}
        onDrop={handleChange}
        name="file"
        types={fileTypes}
        hoverTitle={"Drop here"}
        multiple={multiple || false}
      >
        {file ? (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={input.file_uploader_active}
          >
            <p>{file?.name}</p>
            {/* <p
              onClick={(e) => {
                e.stopPropagation();
                setFile(null);
              }}
              className={input.file_upload_cancel}
            >
              Replace
            </p> */}
          </div>
        ) : (
          <div className={`${input.file_uploader_empty_state} flex-col`}>
            <img src={UploadCloud} width={24} alt="File Upload" />
            <div className="!text-[#6E9170]">
              <p>
                <span className="!font-bold !text-[#305F32]">
                  Click to upload
                </span>{" "}
                or drag and drop.
              </p>
              <p className="text-center">CSV or XLSX</p>
            </div>
          </div>
        )}
      </FileUploader>
    </div>
  );
}

export function PerfectFileUpload({
  title,
  camelCase,
  setFile,
  file,
  isOptional,
  moreRegister,
  isMultiple,
  setValues,
  handleChange,
  fileType,
}) {
  const fileTypes = ["JPG", "PNG", "PDF", "JPEG"];
  console.log("fileType", fileType);

  // console.log("file from component", file);
  // const handleChange = (file) => {
  //   setFile(file);
  // };
  return (
    <div className={input.input_container}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup style={{ color: "red" }}>{!isOptional ? "*" : ""}</sup>
        </label>
      )}
      {file && (
        <FiX
          onClick={(e) => {
            e.stopPropagation();
            setFile(null);
          }}
          className={input.cancel_file_upload}
        />
      )}

      <FileUploader
        classes={input.file_uploader}
        handleChange={handleChange}
        onDrop={handleChange}
        name="file"
        types={fileType || fileTypes}
        hoverTitle={"Drop here"}
        multiple={isMultiple || false}
      >
        {file ? (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={input.file_uploader_active}
          >
            <p>{file?.name}</p>
            {/* <p
      onClick={(e) => {
        e.stopPropagation();
        setFile(null);
      }}
      className={input.file_upload_cancel}
    >
      Replace
    </p> */}
          </div>
        ) : (
          <div className={input.file_uploader_empty_state}>
            <img src={Upload} alt="File Upload" />
            <div>
              <p>
                Drag and drop here or <b>click</b> to upload.
              </p>
              <p>
                {[fileType || fileTypes]?.map((x, index) => {
                  return (
                    <React.Fragment key={index}>
                      {(index ? ", " : "") + ` ${x}`}
                    </React.Fragment>
                  );
                })}
              </p>
            </div>
          </div>
        )}
      </FileUploader>
    </div>
  );
}

export function ProFileUpload({
  title,
  camelCase,
  setFile,
  file,
  isOptional,
  moreRegister,
}) {
  const fileTypes = ["JPG", "PNG", "PDF"];

  const handleChange = (file) => {
    setFile(file);
  };
  return (
    <div className={input.input_container}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          {!isOptional && <sup style={{ color: "red" }}>*</sup>}
        </label>
      )}
      {file && (
        <FiX
          onClick={(e) => {
            e.stopPropagation();
            setFile(null);
          }}
          className={input.cancel_file_upload}
        />
      )}
      <FileUploader
        classes={input.file_uploader}
        handleChange={handleChange}
        onDrop={handleChange}
        name="file"
        types={fileTypes}
        hoverTitle={"Drop here"}

        // multiple={true}
      >
        {file ? (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={input.file_uploader_active}
          >
            <p>{file?.name}</p>
            {/* <p
              onClick={(e) => {
                e.stopPropagation();
                setFile(null);
              }}
              className={input.file_upload_cancel}
            >
              Replace
            </p> */}
          </div>
        ) : (
          <div className={input.file_uploader_empty_state}>
            <img src={Upload} alt="File Upload" />
            <div>
              <p>
                Drag and drop here or <b>click</b> to upload.
              </p>
              <p>(JFG/PNG/PDF)</p>
            </div>
          </div>
        )}
      </FileUploader>
    </div>
  );
}

export function ProFormSelect({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  message,
  multiple,
  moreRegister,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase.replace(/"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  // const ref = useRef(null);

  // const handleAutoFocus = () => {
  //   ref.current.focus();
  // };

  return (
    <div className={`${input.input_container}`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          {!isOptional && <sup style={{ color: "red" }}>*</sup>}
        </label>
      )}
      <div>
        <input
          className={`${input.input_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          disabled={disabled || false}
          // value={value}
          type={type}
          name={camelCase}
          id={camelCase}
          // step={step && "0.01"}
          placeholder={placeholder}
          defaultValue={defaultValue}
          {...register(camelCase, {
            required: {
              value: isOptional ? false : true,
              message: `${title || "This field"} is required.`,
            },
            // ...registerOptions,
          })}
        />
      </div>
      <div className={input.select_holder}>
        <select
          // ref={ref}
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          type={type}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          multiple={multiple && true}
          // defaultValue={defaultValue}
          {...register(camelCase, {
            required: {
              value: isOptional ? false : true,
              message: `${title || "This feild"} is required.`,
            },
            ...moreRegister,
          })}
          disabled={disabled === "disabled" ? true : false}
        >
          {/* <option value="" checked={defaultValue && false}></option>
          {defaultValue ? (
            <option value={defaultId} checked>
              {defaultValue || "a"}
            </option>
          ) : (
            ""
          )}
          {array || null} */}
        </select>
        <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span>
      </div>
      <>
        {(errors || errors?.[inputName]) && (
          <small className={input.form__error__message}>
            {errors?.[inputName]?.message ||
              errors?.[groupName]?.[groupIndex]?.[fieldInputName]?.message}
          </small>
        )}
        {/* <br /> */}
        {message && <small>{message}</small>}
      </>
    </div>
  );
}

export function ReactSelect({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  message,
  multiple,
  moreRegister,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const animatedComponents = makeAnimated();

  const inputName = camelCase.replace(/"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  // const ref = useRef(null);

  // const handleAutoFocus = () => {
  //   ref.current.focus();
  // };

  const colourOptions = [
    { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
    { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
    { value: "purple", label: "Purple", color: "#5243AA" },
    { value: "red", label: "Red", color: "#FF5630", isFixed: true },
    { value: "orange", label: "Orange", color: "#FF8B00" },
    { value: "yellow", label: "Yellow", color: "#FFC400" },
    { value: "green", label: "Green", color: "#36B37E" },
    { value: "forest", label: "Forest", color: "#00875A" },
    { value: "slate", label: "Slate", color: "#253858" },
    { value: "silver", label: "Silver", color: "#666666" },
  ];

  return (
    <div className={`${input.input_container}`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          {!isOptional && <sup style={{ color: "red" }}>*</sup>}
        </label>
      )}

      <div className={input.select_holder}>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          closeMenuOnSelect={false}
          components={animatedComponents}
          // defaultValue={[colourOptions[4], colourOptions[5]]}
          isMulti={false}
          options={colourOptions}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: "1px solid #d9e9da",
              backgroundColor: "var(--greenStep_One)",
              padding: "0.3rem",
              borderRadius: "0.5rem",
              borderColor: "#d9e9da",
              outline: "#d9e9da",
            }),
          }}
        />
        {/* <select
          // ref={ref}
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          }`}
          type={type}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          multiple={multiple && true}
          // defaultValue={defaultValue}
          {...register(camelCase, {
            required: {
              value: isOptional ? false : true,
              message: `${title || "This feild"} is required.`,
            },
            ...moreRegister,
          })}
          disabled={disabled === "disabled" ? true : false}
        >
          {/* <option value="" checked={defaultValue && false}></option>
          {defaultValue ? (
            <option value={defaultId} checked>
              {defaultValue || "a"}
            </option>
          ) : (
            ""
          )}
          {array || null} */}
        {/* </select> */}
        {/* <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span> */}
      </div>
      <>
        {(errors || errors?.[inputName]) && (
          <small className={input.form__error__message}>
            {errors?.[inputName]?.message ||
              errors?.[groupName]?.[groupIndex]?.[fieldInputName]?.message}
          </small>
        )}
        {/* <br /> */}
        {message && <small>{message}</small>}
      </>
    </div>
  );
}

export function ReactSelects({
  camelCase,
  title,
  isOptional,
  message,
  options, // Add a prop for colourOptions
  selectedOptions, // Add a prop for selected options
  onChange, // Add a callback prop for updating selected options
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const animatedComponents = makeAnimated();

  const inputName = camelCase.replace(/"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  return (
    <div className={`${input.input_container}`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          {!isOptional && <sup style={{ color: "red" }}>*</sup>}
        </label>
      )}

      <div className={input.select_holder}>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          closeMenuOnSelect={false}
          components={animatedComponents}
          value={selectedOptions} // Set the value to manage selection
          onChange={onChange} // Use the provided onChange callback to update the parent state
          isMulti={false}
          options={options} // Use the dynamic options prop
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: "1px solid #d9e9da",
              backgroundColor: "var(--greenStep_One)",
              padding: "0.3rem",
              borderRadius: "0.5rem",
              borderColor: "#d9e9da",
              outline: "#d9e9da",
            }),
          }}
        />
      </div>
      <>
        {(errors || errors?.[inputName]) && (
          <small className={input.form__error__message}>
            {errors?.[inputName]?.message ||
              errors?.[groupName]?.[groupIndex]?.[fieldInputName]?.message}
          </small>
        )}
        {message && <small>{message}</small>}
      </>
    </div>
  );
}

export function AyotayoCheckBox({
  isRequired,
  name,
  camelCase,
  value,
  style,
  ariaLabel,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div style={{ ...style }} className={DashboardStyle.checkbox_style}>
      <label
        style={{
          marginBottom: "0px",
        }}
        htmlFor={value}
        aria-label={ariaLabel || name}
      >
        <input
          {...register(`${camelCase}.${value}`, {
            required: isRequired,
          })}
          type="checkbox"
          id={value}
          value={value} // Set the value of the checkbox to the department name
        />
        {name || ""}
      </label>
      {errors && errors[camelCase] && errors[camelCase][value] && (
        <small className={input.form__error__message}>
          {errors[camelCase][value].message}
        </small>
      )}
    </div>
  );
}

export function CheckBox({
  isRequired,
  name,
  isHeading,
  onClick,
  camelCase, // Assuming camelCase is a string representing the property name
  group,
  value,
  moreRegister,
  style,
  defaultValue,
  ariaLabel, // Optional prop for accessibility
  disabled = false, // Add disabled prop with default value
}) {
  const {
    register,
    formState: { errors }, // Using formState for errors
  } = useFormContext();

  return (
    <div style={{ ...style }} className={DashboardStyle.checkbox_style}>
      <label
        onClick={onClick ? () => onClick() : undefined}
        style={{
          marginBottom: "0px",
          // fontWeight: isHeading === true && "500", // Uncomment if using heading styles
          // marginBottom: isHeading === true ? "40px" : "0.8rem", // Uncomment if using heading styles
        }}
        htmlFor={value}
        aria-label={ariaLabel || name} // Use ariaLabel if provided, otherwise fallback to name
      >
        <input
          {...register(`${camelCase}`, {
            value: isRequired === false ? false : true,
            ...moreRegister,
          })}
          type="checkbox"
          id={value}
          disabled={disabled}
        />
        {name || ""}
      </label>
      {errors &&
        errors[camelCase] && ( // Display error if available
          <small className={input.form__error__message}>
            {errors[camelCase].message}
          </small>
        )}
    </div>
  );
}

export function RadioBox({
  name,
  isHeading,
  camelCase,
  group,
  value,
  moreRegister,
  style,
}) {
  const { register } = useFormContext();

  return (
    <div style={{ ...style }} className={DashboardStyle.checkbox_style}>
      <label
        style={{
          fontWeight: isHeading === true && "500",
          marginBottom: isHeading === true ? "40px" : "0.8rem",
        }}
        htmlFor={value}
      >
        {" "}
        <input
          id={value}
          {...register(`${camelCase}`, {
            required: {
              value: true,
              message: "yeah",
            },
            ...moreRegister,
          })}
          value={value}
          name={group || ""}
          type="radio"
        />
        {name || ""}
      </label>
    </div>
  );
}

export function SlideCheckBox({
  name,
  isHeading,
  camelCase,
  group,
  moreRegister,
  style,
  placeholder,
  isDisabled,
  isOptional,
  title,
  value,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  // console.log({ camelCase, value, moreRegister, name, group });
  // const inputName = camelCase?.replace(/"/g, "");

  return (
    <div
      style={{ ...style, display: "flex", alignItems: "center", gap: "10px" }}
      className={DashboardStyle.checkbox_style}
    >
      <label className={input.switch}>
        <input
          style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
          value={value}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          {...register(camelCase, {
            required: {
              value: isOptional === false ? false : true,
              message: `${title || "This feild"} is required.`,
            },
            ...moreRegister,
          })}
          type="checkbox"
          disabled={isDisabled}
        />
        <span className={`${input.slider} ${input.round}`}></span>
      </label>{" "}
      <p style={{ color: "var(--primary-color)", fontSize: "0.87rem" }}>
        {name}
      </p>
    </div>
  );
}

// FINANCE ALTERNATES

export function FormInputAlt({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  disabled,
  className,
  message,
  onFocus,
  onBlur,
  onChange,
  value,
  defaultValue,
  registerOptions,
  step,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase?.replace(/"/g, "");

  return (
    <div className={input.input_container}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup className="text-red-500 text-lg relative top-0.5 ml-2">
            {isOptional === true ? "" : "*"}
          </sup>
        </label>
      )}
      {/* <div> */}{" "}
      <input
        className={`${input.input_field} ${
          errors?.[inputName] && input.form__error__message_border
        }`}
        disabled={disabled || false}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        type={type}
        name={camelCase}
        id={camelCase}
        step={step && "0.01"}
        placeholder={placeholder || `Enter ${title}`}
        defaultValue={defaultValue}
        {...register(camelCase, {
          onChange,
          required: {
            value: isOptional === true ? false : true,
            message: `${title || "This field"} is required.`,
          },
          ...registerOptions,
        })}
      />
      <small className={input.form__error__message}>
        {(errors || errors?.[inputName]) &&
          `${errors?.[inputName]?.message || ""}`}
      </small>
      {/* )} */}
    </div>
  );
}

export function FormSelectAlt({
  camelCase,
  placeholder,
  title,
  type,
  isOptional,
  defaultValue,
  defaultId,
  array,
  disabled,
  message,
  multiple,
  moreRegister,
  isLoading,
  arrayLenghtNotice,
}) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputName = camelCase.replace(/"/g, "");
  const fieldInputName = inputName?.split(".")[2];
  const groupIndex = inputName?.split(".")[1]?.replace(/[\])}[{(]/g, "");
  const groupName = inputName?.split(".")[0];

  // const ref = useRef(null);

  // const handleAutoFocus = () => {
  //   ref.current.focus();
  // };

  return (
    <div className={`${input.input_container} w-[100%]`}>
      {title && (
        <label className={input.input_title} htmlFor={camelCase}>
          {title}
          <sup className="text-red-500 text-lg relative top-0.5 ml-2">
            {isOptional === true ? "" : "*"}
          </sup>
        </label>
      )}
      <div className={input.select_holder}>
        <select
          // ref={ref}
          className={`${input.input_field} ${input.select_field} ${
            errors?.[inputName] && input.form__error__message_border
          } !text-customGreen`}
          type={type}
          name={camelCase}
          id={camelCase}
          placeholder={placeholder}
          multiple={multiple && true}
          // defaultValue={defaultValue}
          {...register(camelCase, {
            required: {
              value: isOptional === true ? false : true,
              message: `${title || "This feild"} is required.`,
            },
            ...moreRegister,
          })}
          disabled={disabled === "disabled" ? true : false}
        >
          {/* {!defaultValue && ( */}
          <option value="">{placeholder}</option>
          {/* )} */}
          {defaultValue ? (
            <option value={defaultId} selected>
              {defaultValue || "a"}
            </option>
          ) : (
            ""
          )}
          {array || null}
        </select>
        <span className={input.select_key_dev}>
          <FiChevronDown className="down" />
        </span>
      </div>
      {/* <br /> */}
      <>
        {(errors || errors?.[inputName]) && (
          <small className={input.form__error__message}>
            {errors?.[inputName]?.message ||
              errors?.[groupName]?.[groupIndex]?.[fieldInputName]?.message}
          </small>
        )}
        {/* <br /> */}
        {isLoading && <small>Loading...</small>}
        {!array?.length &&
          (<small>{arrayLenghtNotice}</small> || (
            <small>No available Options</small>
          ))}
      </>
    </div>
  );
}
